import React from "react";

const TableManagePage = React.lazy(() => import("../../../pages/sales/table/TableManagePage"));

const TableRoutes = [
    {
        path: "",
        children: [{ path: "", element: <TableManagePage /> }],
    },
];

export default TableRoutes;
